import React from "react"

export function StatusColumnFormatter(cellContent, row, rowIndex, { updateStatus, processing }) {
  const callUpdateStatus = async (row, value) => {
    updateStatus(row.id, value);
  }

  if (processing === row.id) {
    return (<i className="fas fa-circle-notch fa-spin"></i>)
  }
  else {
    return (
      <select
        className="form-control"
        value={row.status}
        onChange={(e) => callUpdateStatus(row, e.target.value)}
      >
        <option value="active">Active</option>
        <option value="inactive">Inactive</option>
      </select>
    )
  }
}